module.exports = __webpack_public_path__ + "img/toilet-paper-slash.70212417.svg";